import { usePointerSwipe as H, onClickOutside as $ } from "@vueuse/core";
import { ref as p, unref as P, computed as h, defineComponent as C, toRefs as A, watch as E, resolveComponent as I, openBlock as k, createBlock as F, withCtx as N, createElementVNode as y, mergeProps as V, createElementBlock as Y, normalizeClass as S, createCommentVNode as w, renderSlot as B } from "vue";
import { useTheme as j, usePopoverState as z } from "@onereach/ui-components-common/hooks";
import { O as D } from "./OrOverlay-BjrghiC-.mjs";
import { _ as R } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
var a = /* @__PURE__ */ ((e) => (e.Basic = "basic", e.Advanced = "advanced", e))(a || {});
function T(e, f, t, n, c) {
  const d = p({}), r = p(!1), u = j(), l = (o) => n.value === a.Basic || o.composedPath().includes(f.value) && t.value, { isSwiping: g } = H(e, {
    threshold: 12,
    onSwipe(o) {
      if (r.value = l(o), n.value === a.Advanced) {
        const s = P(e);
        d.value = {
          transitionProperty: "none",
          minHeight: `${s.clientHeight - o.offsetY}px`,
          maxHeight: `${s.clientHeight - o.offsetY}px`
        };
      }
    },
    onSwipeEnd(o, s) {
      if (!l(o) && n.value === a.Advanced)
        switch (s) {
          case "up":
          case "UP":
            t.value = !0;
            break;
          case "down":
          case "DOWN":
            t.value ? t.value = !1 : c();
            break;
        }
    }
  });
  return {
    rootInlineStyles: h(() => n.value === a.Basic ? {
      transitionProperty: "min-height, max-height",
      minHeight: "0",
      maxHeight: `calc(100% - ${u.spacing.xl})`
    } : g.value && !r.value ? d.value : t.value ? {
      transitionProperty: "min-height, max-height",
      minHeight: `calc(100% - ${u.spacing.xl})`,
      maxHeight: `calc(100% - ${u.spacing.xl})`
    } : {
      transitionProperty: "min-height, max-height",
      minHeight: "0",
      maxHeight: "50%"
    })
  };
}
const U = [
  // Position
  "fixed",
  "left-0",
  "right-0",
  "bottom-0",
  // Layout
  "layout-column",
  // Shape
  "rounded-t-lg",
  // Elevation
  "shadow-contextual",
  "dark:shadow-contextual-dark",
  // Typography
  "typography-body-2-regular",
  // Theme
  "theme-background-default",
  "dark:theme-background-default-dark",
  "theme-foreground-default",
  "dark:theme-foreground-default-dark"
], W = {
  [a.Basic]: [],
  [a.Advanced]: [
    // Box
    "max-h-[50%]",
    // Transition
    "transition-[min-height]",
    "transition-[max-height]"
  ]
}, _ = [
  // Layout
  "layout-row justify-center",
  // Interactivity
  "interactivity-drag",
  // Box
  "after:w-2xl",
  "after:h-xs",
  // Spacing
  "px-sm",
  "py-sm",
  // Shape
  "after:rounded-full",
  // Theme
  "after:bg-outline",
  "after:dark:bg-outline"
], q = [
  // Layout (empty)
  "empty:hidden",
  // Spacing
  "px-lg",
  "py-md",
  // Typography
  "typography-headline-3"
], G = [
  // Layout
  "layout-column",
  "grow"
], J = C({
  name: "OrBottomSheet",
  components: {
    OrOverlay: D
  },
  inheritAttrs: !1,
  props: {
    isOpen: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: () => a.Advanced
    },
    isFullscreen: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:state",
    "open",
    "close"
  ],
  expose: [
    "root",
    "state",
    "fullscreen",
    "open",
    "close",
    "toggle"
  ],
  setup(e, f) {
    const t = p(), n = p(), { variant: c, isOpen: d } = A(e), { state: r, open: u, close: l, toggle: g } = z(d, f.emit), m = p(e.isFullscreen), o = h(() => [
      "or-bottom-sheet-v3",
      ...U,
      ...W[e.variant]
    ]), s = h(() => [
      ..._
    ]), x = h(() => [
      ...q
    ]), O = h(() => [
      ...G,
      m.value || c.value === "basic" ? "overflow-y-auto" : "overflow-hidden"
    ]), { rootInlineStyles: b } = T(t, n, m, c, l);
    return E(r, (v) => {
      v === "closed" && (m.value = e.isFullscreen);
    }), $(t, (v) => {
      v.composedPath().some(({ classList: i }) => (i == null ? void 0 : i.contains("or-popover-v3")) || (i == null ? void 0 : i.contains("or-bottom-sheet-v3"))) || l();
    }), {
      root: t,
      content: n,
      rootStyles: o,
      rootInlineStyles: b,
      handleStyles: s,
      headerStyles: x,
      contentStyles: O,
      state: r,
      fullscreen: m,
      open: u,
      close: l,
      toggle: g
    };
  }
});
function K(e, f, t, n, c, d) {
  const r = I("OrOverlay");
  return e.state === "open" ? (k(), F(r, {
    key: 0,
    fullscreen: e.fullscreen
  }, {
    default: N(() => [
      y("div", V(e.$attrs, {
        ref: "root",
        class: e.rootStyles,
        style: e.rootInlineStyles
      }), [
        e.variant === "advanced" ? (k(), Y("div", {
          key: 0,
          class: S(e.handleStyles)
        }, null, 2)) : w("", !0),
        y("div", {
          class: S(e.headerStyles)
        }, [
          B(e.$slots, "header")
        ], 2),
        y("div", {
          ref: "content",
          class: S(e.contentStyles)
        }, [
          B(e.$slots, "default")
        ], 2)
      ], 16)
    ]),
    _: 3
  }, 8, ["fullscreen"])) : w("", !0);
}
const te = /* @__PURE__ */ R(J, [["render", K]]);
export {
  a as B,
  te as O
};
//# sourceMappingURL=OrBottomSheet-CJxmY84p.mjs.map
